import React from "react";
import { ReactNodeLike } from "prop-types";

import "../../styles/index.base.scss";

import { IFooter, IHeader, ISite } from "../../interfaces";
import Header from "../header";
import CmsFooter from "../footer";
import CssOverride from "../css-override";

// prettier-ignore
interface Props {
  children: ReactNodeLike;
  header: IHeader;
  footer: IFooter;
  site: ISite;
  user: Object;
}

class Layout extends React.Component<Props> {
  FormattedFooter: any = () => {
    return <div></div>;
  };

  constructor(props) {
    super(props);

    const { footer, site }: { footer: IFooter; site: ISite } = props;
    if (footer != null) {
      this.FormattedFooter = CssOverride(CmsFooter, footer, { site, footer });
    }
  }

  render() {
    return (
      <>
        <Header user={this.props.user} {...this.props.header} />
        <main>{this.props.children}</main>
        <this.FormattedFooter />
      </>
    );
  }
}

export default Layout;
